"use client";

import Image from "next/image";
import { useTranslations } from "next-intl";
import { BlurImage } from "@/components/core";
import { Button, XIcon } from "@/components/ui";
import { useRouter } from "@/i18n/navigation";

interface ShopDetailBannerProps {
  logo_url: string;
  shop_name: string;
  banner_url: string;
}

export const ShopDetailBanner = ({
  logo_url,
  shop_name,
  banner_url,
}: ShopDetailBannerProps) => {
  const router = useRouter();
  const t = useTranslations("shop");
  return (
    <div className="w-full flex justify-center bg-bg-primary">
      <div className="w-full max-w-screen-sm md:max-w-screen-md mx-auto">
        <div className="px-4 py-2 flex items-center justify-between">
          <span className="line-clamp-1 pe-1">
            {t("detail.shopNamePrefix")}
            {shop_name}
          </span>
          <Button size={"icon"} variant={"light"} onClick={router.back}>
            <XIcon />
          </Button>
        </div>
        <div className="w-full h-44 bg-bg-secondary border-b-2 border-dashed border-stroke-light relative mb-14">
          <Image
            className="ps-10 object-cover"
            fill
            sizes="(max-width: 640px) 100vw, 768px"
            src={"/images/products/circle-bg.svg"}
            alt=""
            aria-hidden
          />

          <BlurImage
            wrapperClassName="w-full h-full"
            fit="contain"
            loading="lazy"
            fill
            sizes="(max-width: 640px) 100vw, 768px"
            src={banner_url}
            alt="shop banner"
          />

          <BlurImage
            wrapperClassName="absolute right-4 -bottom-1/4 overflow-hidden rounded-full border-2 border-stroke-primary bg-bg-primary"
            fit="cover"
            className="aspect-square"
            src={logo_url}
            alt="shop logo"
            width={88}
            height={88}
            loading="lazy"
          />
        </div>
      </div>
    </div>
  );
};
